module.exports = __webpack_public_path__ + "img/3@3x.4cf147be.png";